// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--UIjr5","container":"container--i1xkP","content":"content--kPFYz","fadeSlideUp":"fadeSlideUp--VxbHT"};